import {
  TAC_ADD_ITEM,
  TAC_ADD_MULTIPLE,
  TAC_LOAD,
  TAC_REMOVE_ITEM,
  TAC_SET_USE_MOUNTING_RAIL,
  TAC_SET_WALL,
  TAC_UPDATE_ITEM,
  TAC_UPDATE_MULTIPLE,
} from '../../actionConstants';
import tacHelpers from '../tacHelpers';

export const filterActions = (
  incomingAction,
  currentState,
  previousHistory
) => {
  const whitelist = [
    TAC_LOAD,
    TAC_ADD_ITEM,
    TAC_ADD_MULTIPLE,
    TAC_UPDATE_ITEM,
    TAC_UPDATE_MULTIPLE,
    TAC_REMOVE_ITEM,
    TAC_SET_USE_MOUNTING_RAIL,
  ];

  if (whitelist.some(action => action === incomingAction.type)) {
    if (incomingAction.meta?.automatedUpdate) {
      return false;
    }

    return (
      !previousHistory.present ||
      !tacHelpers.isUnchanged(currentState, previousHistory.present)
    );
  }
  if (incomingAction.type === TAC_SET_WALL) {
    return !!incomingAction.meta?.isPersistent;
  }

  return false;
};
